import { useMutation } from "@tanstack/react-query";

import { createContractPayment } from "../services/goHireService";
import { CreateContractPaymentResponse } from "../types/contract.types";

export const useCreateContractPayment = (options?: {
  onSuccess?: (data: CreateContractPaymentResponse["data"]) => void;
}) => {
  return useMutation<CreateContractPaymentResponse["data"], Error, number>({
    mutationFn: createContractPayment,
    onSuccess: (data) => {
      options?.onSuccess?.(data);
    },
  });
};
